import isBlank from "@sedan-utils/is-blank";
import { CustomApiProps } from "../../storyV2/adapter/CustomApiAdapter";
import { FuncResponse, FuncResponseType, FunctionBase, } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { JsonUtil } from "../../cutil/JsonUtil";
import { settings } from "../../kernel/Settings";
import qs from "qs";
export class CustomApiFunction extends FunctionBase {
    constructor(brainClient, authStore, topicService, webscoketService) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.topicService = topicService;
        this.webscoketService = webscoketService;
        this.props = new CustomApiProps();
    }
    async run(input, identityInfo, variableList = [], page = 1) {
        const pubsub_topic = await this.topicService.generateTopic(identityInfo, "customApi");
        const httpPromise = this.httpDataSource(input, pubsub_topic, identityInfo, variableList);
        const websocketPromise = this.webscoketService.websocketDataSource(pubsub_topic, identityInfo);
        const res = await Promise.race([httpPromise, websocketPromise])
            .then(resResponse => {
            return Promise.resolve(resResponse);
        })
            .catch(error => {
            return Promise.reject(error);
        });
        return new FuncResponse(FuncResponseType.CUSTOM_API, res);
    }
    async httpDataSource(input, pubsub_topic, identityInfo, variableList = []) {
        if (isBlank(this.props.url)) {
            return Promise.reject("url is blank");
        }
        let headers = {};
        if (this.props.headerList != undefined) {
            this.props.headerList.forEach(header => {
                const selected = header["selected"];
                if (selected) {
                    let value = header["value"];
                    let name = header["name"];
                    if (value && value.includes("${brainAuthToken}")) {
                        if (!isBlank(this.authStore.state.brainToken)) {
                            value = value.replace("${brainAuthToken}", this.authStore.state.brainToken);
                        }
                        else if (!isBlank(this.authStore.state.guestToken)) {
                            name = "Brain-Guest-User-Key";
                            value = this.authStore.state.guestToken;
                        }
                    }
                    if (value && value.includes("${currentSourceNodeValue}")) {
                        value = value.replace(/\$\{currentSourceNodeValue\}/g, input);
                    }
                    headers[name] = value;
                }
            });
        }
        let url = this.props.url?.replace(/\$\{currentSourceNodeValue\}/g, input);
        let bodyParam = (this.props.bodyParam = FunctionUtil.bodyParamReplace(input, this.props.bodyParam));
        variableList.forEach(variable => {
            const variableName = new RegExp(`\\$\\{${variable.name}\\}`, "g");
            url = url?.replace(variableName, variable.value);
            bodyParam = bodyParam?.replace(variableName, variable.value);
            headers = Object.fromEntries(Object.entries(headers).map(([key, value]) => [key, value.replace(variableName, variable.value)]));
        });
        /// 如果是 api 服务器，添加 pubsub_topic
        if (url?.startsWith(settings.API)) {
            return this.sendRequestWithPubsubTopic(url ?? "", this.props.method ?? "get", headers, bodyParam, pubsub_topic, identityInfo);
        }
        else {
            return this.sendRequest(url ?? "", this.props.method ?? "get", headers, bodyParam, identityInfo);
        }
    }
    async sendRequest(url, method, headers, body, identityInfo) {
        return this.brainClient.global.request(url, method, headers, body, FunctionUtil.createAbortUuid(identityInfo));
    }
    async sendRequestWithPubsubTopic(url, method, headers, body, pubsub_topic, identityInfo) {
        return new Promise((resolve, reject) => {
            if (method === "get") {
                const [path, search] = url.split("?");
                const params = qs.parse(search);
                const newParams = {
                    ...params,
                    pubsub_topic,
                };
                const newUrl = [path, qs.stringify(newParams)].join("?");
                return this.sendRequest(newUrl, method, headers, undefined, identityInfo).then(res => {
                    if (res.status === 200 || res.status === 201) {
                        resolve(res);
                    }
                });
            }
            else {
                const param = JsonUtil.parse(body);
                const newParams = {
                    ...param,
                    pubsub_topic,
                };
                return this.sendRequest(url, method, headers, newParams, identityInfo).then(res => {
                    if (res.status === 200 || res.status === 201) {
                        resolve(res);
                    }
                });
            }
        });
    }
}
